import { defineStore } from 'pinia'
import { getLocalState, setLocalState } from './helper'
import {
  fetchUpdateChatRoomUsingContext,
} from '@/api/chat'

export const useChatStore = defineStore('chat-store', {
  state: (): Chat.ChatState => getLocalState(),

  getters: {
    getChatHistoryByCurrentActive(state: Chat.ChatState) {
      const index = state.history.findIndex(item => item.uuid === state.active)
      if (index !== -1)
        return state.history[index]
      return null
    },

    getChatByUuid(state: Chat.ChatState) {
      return (uuid?: string) => {
        if (uuid)
          return state.chat.find(item => item.uuid === uuid)?.data ?? []
        return state.chat.find(item => item.uuid === state.active)?.data ?? []
      }
    },
  },

  actions: {
    isPin(uuid: string | number) {
      const item = this.history.find(i => i.uuid === uuid)
      return !!item?.order
    },
    async  setUsingContext(context: boolean, roomId: number) {
      await fetchUpdateChatRoomUsingContext(context, roomId)
      this.recordState()
    },

    async setActive(uuid: string) {
      this.active = uuid
      // return await this.reloadRoute(uuid)
    },

    getChatByUuidAndIndex(uuid: string, index: number) {
      if (!uuid) {
        if (this.chat.length)
          return this.chat[0].data[index]
        return null
      }
      const chatIndex = this.chat.findIndex(item => item.uuid === uuid)
      if (chatIndex !== -1)
        return this.chat[chatIndex].data[index]
      return null
    },

    recordState() {
      setLocalState(this.$state)
    },
  },
})
